import React from 'react';

import { Linkedin } from 'styled-icons/boxicons-logos/Linkedin';
import { Envelope } from 'styled-icons/boxicons-solid/Envelope';
import { Phone } from 'styled-icons/boxicons-solid/Phone';

import * as S from './styled';

const SocialLinks = (props) => {
  return (
    <S.SocialLinksList style={props.style}>
      <S.SocialLinksItem>
        <S.SocialLinksLink
          href="/contact"
          title="Mail"
        >
          <Envelope size="25" />
        </S.SocialLinksLink>
      </S.SocialLinksItem>
      <S.SocialLinksItem>
        <S.SocialLinksLink
          href="https://www.linkedin.com/company/essentia-consultancy-b-v"
          title="Linkedin"
        >
          <Linkedin size="25" />
        </S.SocialLinksLink>
      </S.SocialLinksItem>
      <S.SocialLinksItem>
        <S.SocialLinksLink
          href="/contact"
          title="Telephone"
        >
          <Phone size="25" />
        </S.SocialLinksLink>
      </S.SocialLinksItem>
    </S.SocialLinksList>
  );
};

export default SocialLinks;
